// Implements: F-IDN-012
/**
 * Changing the own password (`POST /auth/password-change`, `204`). A `401` is a wrong current
 * password, said in the form: the route is exempt from the session-expiry redirect (H-F6).
 */

import { useMutation } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { changePassword } from "../api/accountApi";

export interface PasswordChange {
  readonly current: string;
  readonly next: string;
}

export function useChangePassword(): UseMutationResult<null, ApiError, PasswordChange> {
  return useMutation<null, ApiError, PasswordChange>({
    mutationFn: async ({ current, next }) => {
      await changePassword(current, next);
      return null;
    },
  });
}
